export default __webpack_public_path__ + "static/media/seguridad_rmn.94763544.pdf";